import React, { useEffect, useRef, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';

const HOCAutoLogout = (WrappedComponent: React.ComponentType<any>) => {
  const AutoLogout = (props: any) => {
    const warningTime = 1000 * 60 * 55; // 55 Minutes
    const signoutTime = 1000 * 60 * 60; // 1 Hour

    const warnTimeoutRef = useRef<number | null>(null);
    const logoutTimeoutRef = useRef<number | null>(null);
    const [showModal, setShowModal] = useState(false);

    const events = ['load', 'mousemove', 'mousedown', 'click', 'scroll', 'keypress'];

    const resetTimeout = () => {
      clearTimeoutFunc();
      setTimeoutFunc();
    };

    const clearTimeoutFunc = () => {
      if (warnTimeoutRef.current !== null) {
        clearTimeout(warnTimeoutRef.current);
      }
      if (logoutTimeoutRef.current !== null) {
        clearTimeout(logoutTimeoutRef.current);
      }
    };

    const setTimeoutFunc = () => {
      warnTimeoutRef.current = window.setTimeout(warn, warningTime);
      logoutTimeoutRef.current = window.setTimeout(logout, signoutTime);
    };

    const warn = () => {
      setShowModal(true);
    };

    const logout = () => {
      destroy();
    };

    const destroy = () => {
      localStorage.clear();
      localStorage.removeItem("token");
      window.location.href = "/login";
      setShowModal(false);
    };

    useEffect(() => {
      events.forEach(event => {
        window.addEventListener(event, resetTimeout);
      });

      setTimeoutFunc();

      return () => {
        clearTimeoutFunc();
        events.forEach(event => {
          window.removeEventListener(event, resetTimeout);
        });
      };
    }, []);

    const handleYes = () => {
      resetTimeout();
      setShowModal(false);
    };

    const handleNo = () => {
      destroy();
    };

    const CustomNotification = () => {
      return (
        <Modal show={showModal} onHide={() => setShowModal(false)} backdrop="static">
          <Modal.Header closeButton>
            <Modal.Title>Auto Logout Warning</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            You will be logged out automatically in 5 minutes, Would you like to continue your work?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleNo}>
              No, Logout
            </Button>
            <Button variant="primary" onClick={handleYes}>
              Yes, Continue
            </Button>
          </Modal.Footer>
        </Modal>
      );
    };

    return (
      <>
        <CustomNotification />
        <WrappedComponent {...props} />
      </>
    );
  };

  return AutoLogout;
};

export default HOCAutoLogout;
